import { useEffect, useState } from "react";
import { Button, required, ReferenceInput, SelectInput, TextInput, useNotify, useRefresh } from "react-admin";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import { Grid } from "@mui/material";
import CustomDateInput from "server/components/Fields/CustomDateInput";
import dataProvider from "server/dataProvider";
import { useWatch } from "react-hook-form";
import { studentRequests } from "api/studentApi";
import FormModal from "server/components/Modals/FormModal";

const FormFields = ({ currentSpecialityId, onChangedChange }) => {
  const selectedSpecialityId = useWatch({ name: "newPreparatorySpecialityId" });

  useEffect(() => {
    onChangedChange(selectedSpecialityId !== currentSpecialityId);
  }, [selectedSpecialityId, currentSpecialityId, onChangedChange]);

  return (
    <Grid
      container
      sx={{ display: "flex", flexDirection: "column" }}
    >
      <ReferenceInput
        source="newPreparatorySpecialityId"
        reference={studentRequests.getPreparatorySpecialitiesSelect()}
      >
        <SelectInput
          label="Специалност"
          optionText="nameBg"
          validate={required()}
        />
      </ReferenceInput>
      <CustomDateInput
        source="orderDate"
        label="Дата на заповедта"
        noTime
      />
      <TextInput
        source="orderNumber"
        label="Номер на заповедта"
      />
    </Grid>
  );
};

const ChangeSpecialtyDialog = ({ record }) => {
  const notify = useNotify();
  const refresh = useRefresh();
  const [isSpecialityChanged, setIsSpecialityChanged] = useState(false);

  const defaultValues = {
    newPreparatorySpecialityId: record?.preparatingForSpecialityId,
    orderDate: null,
    orderNumber: "",
  };

  const handleConfirm = async data => {
    await dataProvider.customRequest(
      studentRequests.updatePreparatorySpeciality(record?.studentEducationId),
      {
        newPreparatorySpecialityId: data.newPreparatorySpecialityId,
        orderDate: data.orderDate,
        orderNumber: data.orderNumber,
      },
      "PUT",
    );
    notify("Специалността е променена успешно", { type: "success" });
    refresh();
  };

  return (
    <FormModal
      titleContent="Смяна на Подготвителна специалност"
      onConfirm={handleConfirm}
      defaultValues={defaultValues}
      confirmEnabled={isSpecialityChanged}
      resetProps={() => setIsSpecialityChanged(false)}
      triggerButton={
        <Button
          startIcon={<AutorenewIcon />}
          size="small"
          label="Подготвителна специалност"
        />
      }
    >
      <FormFields
        currentSpecialityId={record?.preparatingForSpecialityId}
        onChangedChange={setIsSpecialityChanged}
      />
    </FormModal>
  );
};

export default ChangeSpecialtyDialog;
